import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import masterApi from "../api/masterApi";
import { PERFORMANCE_QUERY_KEYS } from "../constants/performanceConstants";

const useFeedbackTypeOptions = () => {
  const feedbackTypesQuery = useQuery({
    queryKey: [PERFORMANCE_QUERY_KEYS.feedbackTypes, "selector"],
    queryFn: () => masterApi.listFeedbackTypes({ page: 1, limit: 100 }),
  });

  const feedbackTypes = useMemo(() => {
    const payload = feedbackTypesQuery.data;

    if (Array.isArray(payload?.data)) {
      return payload.data;
    }

    if (Array.isArray(payload?.data?.rows)) {
      return payload.data.rows;
    }

    if (Array.isArray(payload?.rows)) {
      return payload.rows;
    }

    return [];
  }, [feedbackTypesQuery.data]);

  const feedbackTypeOptions = useMemo(
    () =>
      feedbackTypes.map((type) => ({
        value: type._id,
        label: type.code ? `${type.name} (${type.code})` : type.name,
      })),
    [feedbackTypes],
  );

  return {
    feedbackTypeOptions,
    isLoading: feedbackTypesQuery.isLoading,
    isError: feedbackTypesQuery.isError,
    error: feedbackTypesQuery.error,
    refetch: feedbackTypesQuery.refetch,
  };
};

export default useFeedbackTypeOptions;
